import { render } from "./AgentDashboard.vue?vue&type=template&id=4335c7c0"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__